/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Icon,
  Popup,
  Loader,
  Header,
  List
} from 'semantic-ui-react';
import { AutoSizer, Table, Column } from 'react-virtualized';
import cx from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars-2';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import SecurityDetailModal from '../Modal/SecurityDetailModal';
import LitigatorDetailModal from '../Modal/LitigatorDetailModal';
import TextWithEllipsis from '../Extensions/TextWithEllipsis';
import ComponentDetailModal from '../Modal/ComponentDetailModal';
import './ScannedFileRow.css';

class ScannedFileRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupStatus: {
        treePopup: false,
        versionPopup: false,
      },
      isLoadingPopup: false,
      isOpenMLD: false,
      isOpenMSD: false,
      activeTreeIndex: '',
      activeVersionIndex: '',
      activeModalIndex: '',
      possibleVersionList: [],
      cveData: {},
      selectedCode: '',
      litigatorData: {},
      isOpenCDM: false,
      moreInfo: {},
      showAllSecurities: false,
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleDetailModal = (rowData, id) => {
    const popupStatus = {
      treePopup: false,
      versionPopup: false,
    };

    this.setState({
      popupStatus,
      activeModalIndex: id,
      isOpenCDM: true,
      moreInfo: rowData,
    });
  };

  handleVersionPopupOpen = (uid, sfid, cid) => {
    const status = {
      treePopup: false,
      versionPopup: true,
    };

    this.setState({
      popupStatus: status,
      activeVersionIndex: cid,
      isLoadingPopup: true,
    }, () => {
      api
        .getComponentVersionWithDetail(uid, sfid, cid)
        .then((res) => {
          const data = res.response;
          this.setState({
            possibleVersionList: data.versions,
            isLoadingPopup: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const initStatus = {
            treePopup: false,
            versionPopup: false,
          };
          this.setState({
            popupStatus: initStatus,
            activeVersionIndex: '',
            isLoadingPopup: false,
          });
        });
    });
  };

  handleTreeOpen = (id) => {
    const popupStatus = {
      treePopup: true,
      versionPopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: id,
    });
  };

  handleSecurityDetailModal = (e, value, securityId) => {
    const data = {
      security_name: value,
    };
    if (securityId) {
      data.security_id = securityId;
    }

    api.getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleLitigatorDetailModal = (e, string) => {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api.getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  closePopup = () => {
    const { isOpenMLD, isOpenMSD } = this.state;

    if (isOpenMLD || isOpenMSD) {
      return;
    }

    const popupStatus = {
      treePopup: false,
      versionPopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
      activeVersionIndex: '',
      activeModalIndex: '',
      showAllSecurities: false
    });
  };

  closeModal = () => {
    this.setState({
      litigatorData: {},
      cveData: {},
      moreInfo: {},
      selectedCode: '',
      activeModalIndex: '',
      isOpenMLD: false,
      isOpenMSD: false,
      isOpenCDM: false,
    });
  };

  filterSecurities = (list) => {
    const { showAllSecurities } = this.state;
    if (showAllSecurities) {
      return list;
    }
    return list.filter((item) => { return item.is_vulnerable; });
  };

  setShowAllSecurities = (value) => {
    this.setState({
      showAllSecurities: value,
    });
  };

  render() {
    const {
      parentRowData,
      t,
      uid,
      sfid
    } = this.props;

    const {
      popupStatus,
      activeTreeIndex,
      activeVersionIndex,
      activeModalIndex,
      isLoadingPopup,
      possibleVersionList,
      litigatorData,
      isOpenMLD,
      isOpenMSD,
      cveData,
      selectedCode,
      isOpenCDM,
      moreInfo,
      showAllSecurities,
    } = this.state;

    const flattenedData = parentRowData.components;

    const cellRendererMatchType = ({ cellData }) => {
      return (
        <div
          className="tac border-bottom"
        >
          <TextWithEllipsis className="" as="span" text={cellData} />
        </div>
      );
    };

    const cellRendererScore = ({ cellData }) => {
      return (
        <div
          className="tac border-bottom"
        >
          <TextWithEllipsis className="" as="span" text={cellData} />
        </div>
      );
    };

    const cellRendererName = ({ cellData, rowData }) => {
      const {
        homepage,
        cpe_vendor,
        cpe_product,
        download_url
      } = rowData;

      if (cpe_vendor.length !== 0 || cpe_product.length !== 0 || homepage !== '' || download_url !== '') {
        return (
          <div className="tac border-bottom">
            <div
              className={cx(
                'single_hover_area',
                {
                  active: activeModalIndex === rowData.component_id,
                },
              )}
              onClick={() => {
                return this.handleDetailModal(rowData, rowData.component_id);
              }}
              onKeyUp={() => {
                return this.handleDetailModal(rowData, rowData.component_id);
              }}
            >
              <Icon className="magnify" />
              <TextWithEllipsis className="with_icon" as="span" text={rowData.component_name} />
            </div>
          </div>
        );
      }

      return (
        <div
          className="tac border-bottom"
        >
          <TextWithEllipsis className="" as="span" text={cellData} />
        </div>
      );
    };

    const cellRendererVersion = ({ rowData, cellData }) => {
      if (rowData.has_possible_version) {
        return (
          <Popup
            className="wide_extend_popup"
            trigger={(
              <div
                className={cx(
                  {
                    single_hover_area: rowData.has_possible_version,
                  },
                  {
                    active: popupStatus.versionPopup && activeVersionIndex === rowData.component_id
                  },
                )}
              >
                <Icon className="magnify" />
                <TextWithEllipsis className="with_icon" as="span" text={rowData.component_version} />
              </div>
            )}
            style={{
              marginLeft: '30px',
            }}
            on="click"
            position="bottom left"
            hideOnScroll
            open={
              popupStatus.versionPopup && activeVersionIndex === rowData.component_id
            }
            onOpen={() => {
              return this.handleVersionPopupOpen(uid, sfid, rowData.component_id);
            }}
            onClose={this.closePopup}
          >
            <div className="popup_list_container">
              <Header as="h5" style={{ margin: '0 0 10px 0' }}>
                {t('list.title.possible_version')}
                {' '}
                (
                {possibleVersionList.length}
                )
              </Header>
              {
                isLoadingPopup ? (
                  <div style={{ padding: '50px 0' }}>
                    <Loader
                      active={isLoadingPopup}
                      inline="centered"
                      size="mini"
                    />
                  </div>
                ) : (
                  <div style={{ maxHeight: '220px', overflowY: 'auto', paddingRight: '10px' }}>
                    <List selection relaxed>
                      {possibleVersionList.map((entity) => {
                        return (
                          <List.Item key={entity} style={{ padding: '8px 5px' }}>
                            <List.Content>
                              <List.Description>{entity}</List.Description>
                            </List.Content>
                          </List.Item>
                        );
                      })}
                    </List>
                  </div>
                )
              }
            </div>
          </Popup>
        );
      }

      return (
        <div
          className="tac border-bottom"
        >
          <TextWithEllipsis className="" style={{ paddingLeft: '10px' }} as="span" text={cellData} />
        </div>
      );
    };

    const cellRendererSecurity = ({ rowData }) => {
      const filteredCritical = this.filterSecurities(rowData.securities.critical);
      const filteredHigh = this.filterSecurities(rowData.securities.high);
      const filteredMedium = this.filterSecurities(rowData.securities.medium);
      const filteredLow = this.filterSecurities(rowData.securities.low);

      const totalSecurityCount = filteredCritical.length
      + filteredHigh.length
      + filteredMedium.length
      + filteredLow.length;

      return (
        <div className="sum_td border-bottom">
          <Popup
            trigger={(
              <div
                className="hover_area"
                style={{ outline: 'none' }}
              >
                <table className="sub_table">
                  <colgroup>
                    <col
                      style={{
                        width: '41%',
                      }}
                    />
                    <col
                      style={{
                        width: '33.7%',
                      }}
                    />
                    <col
                      style={{
                        width: '13%',
                      }}
                    />
                    <col style={{ width: 'auto' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td className="tac">
                        <div className="belt_chart">
                          <div className="red">
                            {rowData.security_count.critical}
                          </div>
                          <div className="orange">
                            {rowData.security_count.high}
                          </div>
                          <div className="cheese">
                            {rowData.security_count.medium}
                          </div>
                          <div className="yellow">
                            {rowData.security_count.low}
                          </div>
                        </div>
                        {
                          rowData.has_exploit ? (<Icon name="bug" />) : null
                        }
                      </td>
                      <td className="tac">
                        <div className="belt_chart round">
                          <div className="red">
                            {rowData.license_count.protective}
                          </div>
                          <div className="cheese">
                            {rowData.license_count.permissive}
                          </div>
                          <div className="yellow">
                            {rowData.license_count.others}
                          </div>
                        </div>
                      </td>
                      <td className="tac">
                        {rowData.title_license}
                      </td>
                      <td className="tac">
                        {rowData.litigator_string}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            inverted
            on="click"
            position="bottom left"
            open={
              popupStatus.treePopup && activeTreeIndex === rowData.component_id
            }
            onOpen={() => {
              return this.handleTreeOpen(rowData.component_id);
            }}
            onClose={this.closePopup}
            hideOnScroll={!isOpenMSD}
          >
            <div className="expand_sub_popup">
              <table className="expand_sub_popup_table">
                <colgroup>
                  <col width="230px" />
                  <col width="230px" />
                  <col width="150px" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.security_risk')}
                          (
                          {totalSecurityCount}
                          )
                          <button
                            type="button"
                            onClick={() => { return this.setShowAllSecurities(!showAllSecurities); }}
                            style={{
                              flexShrink: 0,
                              marginLeft: '10px',
                              backgroundColor: showAllSecurities
                                ? '#444'
                                : '#1b1c1d',
                              color: '#fff',
                              border: '1px solid #555',
                              borderRadius: '4px',
                              padding: '2px 8px',
                              cursor: 'pointer',
                              fontSize: '11px',
                              lineHeight: '1.2',
                            }}
                          >
                            {showAllSecurities
                              ? t('list.title.vulnerable_only')
                              : t('list.title.show_all')}
                          </button>
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.license')}
                          (
                          {rowData.licenses.protective.length
                              + rowData.licenses.permissive.length
                              + rowData.licenses.others.length}
                          )
                        </p>
                      </div>
                    </th>
                    <th>
                      <div className="scope_title">
                        <p className="name">
                          {t('list.title.litigator')}
                          (
                          {rowData.litigators.length}
                          )
                        </p>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.risk_level')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.risk_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {filteredCritical.length > 0 ? (
                              <div className="block_wrap">
                                {filteredCritical.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.critical')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_red has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {filteredHigh.length > 0 ? (
                              <div className="block_wrap">
                                {filteredHigh.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.high')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_orange has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {filteredMedium.length > 0 ? (
                              <div className="block_wrap">
                                {filteredMedium.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.medium')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_cheese has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {filteredLow.length > 0 ? (
                              <div className="block_wrap">
                                {filteredLow.map(
                                  (value) => {
                                    return (
                                      <div key={value.code.toString()}>
                                        <div
                                          className="block block_4"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                        >
                                          {t('list.title.low')}
                                        </div>
                                        <div
                                          className="block block_6 bullet bullet_yellow has_link"
                                          style={{
                                            textDecoration: value.is_vulnerable
                                              ? 'none'
                                              : 'line-through',
                                            opacity: value.is_vulnerable ? 1 : 0.6,
                                          }}
                                          onClick={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                          onKeyUp={(e) => { return this.handleSecurityDetailModal(e, value.code, value.security_id); }}
                                        >
                                          <span>{value.code}</span>
                                          {value.is_exploit ? (<Icon name="bug" />) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block block_4">
                              {t('list.title.license_family')}
                            </div>
                            <div className="block block_6">
                              {t('list.title.license_name')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.licenses.protective.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.protective.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.protective')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_red" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.licenses.permissive.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.permissive.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.permissive')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_orange" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                            {rowData.licenses.others.length > 0 ? (
                              <div className="block_wrap">
                                {rowData.licenses.others.map(
                                  (value) => {
                                    return (
                                      <div
                                        key={value.toString()}
                                      >
                                        <div className="block block_4">
                                          {t('list.title.others')}
                                        </div>
                                        <TextWithEllipsis className="block block_6 bullet bullet_disk bullet_yellow" text={value} />
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="round_box">
                        <div className="round_box_header">
                          <div className="block_wrap">
                            <div className="block">
                              {t('list.title.litigator_code')}
                            </div>
                          </div>
                        </div>
                        <div className="round_box_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            {rowData.litigators.length > 0 ? (
                              <div>
                                {rowData.litigators.map(
                                  (value) => {
                                    return (
                                      <div
                                        className="block_wrap"
                                        key={value.toString()}
                                      >
                                        <div style={{ float: 'none' }} className="block">
                                          <TextWithEllipsis
                                            className="has_link"
                                            as="span"
                                            onClick={(e) => { return this.handleLitigatorDetailModal(e, value); }}
                                            text={value}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : null}
                          </Scrollbars>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Popup>
        </div>
      );
    };

    return (
      <div style={{ height: '100%', width: '100%' }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <Table
                width={width}
                height={height}
                headerHeight={0}
                rowHeight={60}
                rowCount={flattenedData.length}
                rowGetter={({ index }) => { return flattenedData[index]; }}
              >
                <Column
                  dataKey="component_match_type"
                  width={width * 0.1035}
                  cellRenderer={cellRendererMatchType}
                />
                <Column
                  dataKey="component_score"
                  width={width * 0.1035}
                  cellRenderer={cellRendererScore}
                />
                <Column
                  dataKey="component_name"
                  width={width * 0.1035}
                  cellRenderer={cellRendererName}
                />
                <Column
                  dataKey="component_version"
                  width={width * 0.1035}
                  cellRenderer={cellRendererVersion}
                />
                <Column
                  width={width * 0.586}
                  dataKey="security_view"
                  cellRenderer={({ rowData }) => { return cellRendererSecurity({ rowData }); }}
                />
              </Table>
            );
          }}
        </AutoSizer>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.closeModal}
          cveData={cveData}
          selectedCode={selectedCode}
        />
        <LitigatorDetailModal
          isOpenMLD={isOpenMLD}
          closeModal={this.closeModal}
          litigatorData={litigatorData}
        />
        <ComponentDetailModal
          isOpenCDM={isOpenCDM}
          translate={t}
          rowData={moreInfo}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

export default withScrollbar(ScannedFileRow);
